import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import React__default__default, { useRef, useState, useMemo } from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../../node_modules/@flixbus/honeycomb/dist/scss/components/header-widgets.scss.js';
import HoneyBem from '../../../packages/honey-bem/honey-bem.js';
import { optionalChildrenValidation } from '../../../prop-types-validators/children-validator.js';
import { useVisibilityToggler } from '../../../hooks/use-visibility-toggler/use-visibility-toggler.js';
import { headerUserWidgetSubMenuValidator } from './header-user-widget-subMenu-validator.js';
import { SubMenuContext } from '../../../contexts/sub-menu-context.js';
import { useSubMenuInitialFocusManager } from '../../../hooks/use-sub-menu-initial-focus-manager/use-sub-menu-initial-focus-manager.js';
import Avatar from '../../avatar/avatar.js';
import { Injecss } from '../../../packages/injecss/injecss.js';

var bem = HoneyBem.init('header-user-widget', styles);
var HeaderUserWidget = function (_a) {
  var extraClasses = _a.extraClasses,
    children = _a.children,
    subMenu = _a.subMenu,
    href = _a.href,
    RouterLink = _a.RouterLink,
    _b = _a.avatar,
    avatar = _b === void 0 ? /*#__PURE__*/React__default__default.createElement(Avatar, {
      "aria-hidden": "true"
    }) : _b,
    rest = __rest(_a, ["extraClasses", "children", "subMenu", "href", "RouterLink", "avatar"]);
  var dropdownRef = useRef(null);
  var targetRef = useRef(null);
  var _c = useState(),
    lastEvent = _c[0],
    setLastEvent = _c[1];
  var handleToggle = function (_isActive, event) {
    return setLastEvent(event);
  };
  var _d = useVisibilityToggler({
      initialActive: false,
      content: dropdownRef.current,
      onToggle: handleToggle,
      arrowEvents: true
    }),
    isExpanded = _d[0],
    buttonEvents = _d[1],
    closeDropdown = _d[2];
  var focusAt = useSubMenuInitialFocusManager({
    isExpanded: isExpanded,
    lastEvent: lastEvent
  });
  var subMenuContextValue = useMemo(function () {
    return {
      setInitialFocus: focusAt,
      hidden: !isExpanded,
      onEscapeCallback: closeDropdown,
      target: targetRef.current
    };
  }, [focusAt, isExpanded, closeDropdown]);
  var handleBlur = function (event) {
    var origin = event.relatedTarget;
    if (origin && dropdownRef.current && dropdownRef.current.contains(origin)) return;
    closeDropdown(event);
  };
  if (subMenu) {
    return /*#__PURE__*/React__default__default.createElement("nav", __assign({
      ref: dropdownRef,
      "aria-labelledby": "".concat(subMenu.props.id, "-toggle-btn"),
      className: bem.b(false, extraClasses),
      onBlur: handleBlur
    }, rest), avatar, /*#__PURE__*/React__default__default.createElement("button", __assign({
      ref: targetRef,
      id: "".concat(subMenu.props.id, "-toggle-btn"),
      className: bem.e('toggle'),
      type: "button",
      "aria-haspopup": "menu",
      "aria-expanded": isExpanded,
      "aria-controls": subMenu.props.id
    }, buttonEvents), children), /*#__PURE__*/React__default__default.createElement(SubMenuContext.Provider, {
      value: subMenuContextValue
    }, subMenu));
  }
  var linkChildren = RouterLink && href ? /*#__PURE__*/React__default__default.createElement(RouterLink, {
    className: bem.e('toggle'),
    to: href
  }, children) : /*#__PURE__*/React__default__default.createElement("a", {
    className: bem.e('toggle'),
    href: href
  }, children);
  return /*#__PURE__*/React__default__default.createElement("div", __assign({
    className: bem.b(false, extraClasses)
  }, rest), avatar, href ? linkChildren : /*#__PURE__*/React__default__default.createElement("span", {
    className: bem.e('toggle')
  }, children));
};
HeaderUserWidget.displayName = 'HeaderUserWidget';
HeaderUserWidget.propTypes = {
  avatar: optionalChildrenValidation('Avatar'),
  children: PropTypes__default.string,
  extraClasses: PropTypes__default.string,
  href: PropTypes__default.string,
  RouterLink: PropTypes__default.oneOfType([PropTypes__default.func, PropTypes__default.object]),
  subMenu: headerUserWidgetSubMenuValidator()
};
var headerUserWidget = Injecss(HeaderUserWidget, styles);

export { HeaderUserWidget, headerUserWidget as default };
